export const data = [
    {
      "name": "John F. Kennedy International Airport",
      "short_name": "JFK"
    },
    {
      "name": "delhi",
      "short_name": "DEL"
    },
    {
      "name": "ahmedabad",
      "short_name": "AMD"
    },
    {
      "name": "Heathrow Airport",
      "short_name": "LHR"
    },
    {
      "name": "Singapore Changi Airport",
      "short_name": "SIN"
    },
    {
      "name": "Charles de Gaulle Airport",
      "short_name": "CDG"
    },
    {
      "name": "Hong Kong International Airport",
      "short_name": "HKG"
    },
    {
      "name": "Frankfurt Airport",
      "short_name": "FRA"
    },
    {
      "name": "Sydney Airport",
      "short_name": "SYD"
    },
    {
      "name": "Incheon International Airport",
      "short_name": "ICN"
    },
    {
      "name": "Amsterdam Airport Schiphol",
      "short_name": "AMS"
    },
    {
      "name": "Munich Airport",
      "short_name": "MUC"
    },
    {
      "name": "Zurich Airport",
      "short_name": "ZRH"
    },
    {
      "name": "San Francisco International Airport",
      "short_name": "SFO"
    },
    {
      "name": "Toronto Pearson International Airport",
      "short_name": "YYZ"
    },
    {
      "name": "Madrid-Barajas Adolfo Suárez Airport",
      "short_name": "MAD"
    },
    {
      "name": "Dallas/Fort Worth International Airport",
      "short_name": "DFW"
    },
    {
      "name": "Denver International Airport",
      "short_name": "DEN"
    },
    {
      "name": "Vancouver International Airport",
      "short_name": "YVR"
    },
    {
      "name": "Barcelona-El Prat Airport",
      "short_name": "BCN"
    },
    {
      "name": "Vienna International Airport",
      "short_name": "VIE"
    },
    {
      "name": "Rome Leonardo da Vinci–Fiumicino Airport",
      "short_name": "FCO"
    },
    {
      "name": "Dublin Airport",
      "short_name": "DUB"
    },
    {
      "name": "Kuala Lumpur International Airport",
      "short_name": "KUL"
    },
    {
      "name": "Manchester Airport",
      "short_name": "MAN"
    },
    {
      "name": "Oslo Airport, Gardermoen",
      "short_name": "OSL"
    },
    {
      "name": "Stockholm Arlanda Airport",
      "short_name": "ARN"
    },
    {
      "name": "Brisbane Airport",
      "short_name": "BNE"
    },
    {
      "name": "Melbourne Airport",
      "short_name": "MEL"
    },
    {
      "name": "Athens International Airport",
      "short_name": "ATH"
    },
    {
      "name": "Auckland Airport",
      "short_name": "AKL"
    },
    {
      "name": "Lisbon Airport",
      "short_name": "LIS"
    },
    {
      "name": "Brussels Airport",
      "short_name": "BRU"
    },
    {
      "name": "Istanbul Airport",
      "short_name": "IST"
    },
    {
      "name": "Moscow Sheremetyevo International Airport",
      "short_name": "SVO"
    },
    {
      "name": "Helsinki Airport",
      "short_name": "HEL"
    },
    {
      "name": "Geneva Airport",
      "short_name": "GVA"
    },
    {
      "name": "Prague Airport",
      "short_name": "PRG"
    },
    {
      "name": "Doha Hamad International Airport",
      "short_name": "DOH"
    },
    {
      "name": "Nice Côte d'Azur Airport",
      "short_name": "NCE"
    },
    {
      "name": "Copenhagen Airport",
      "short_name": "CPH"
    },
    {
      "name": "Mumbai Chhatrapati Shivaji Maharaj International Airport",
      "short_name": "BOM"
    },
    {
      "name": "Seoul Gimpo International Airport",
      "short_name": "GMP"
    },
    {
      "name": "Perth Airport",
      "short_name": "PER"
    },
    {
      "name": "Birmingham Airport",
      "short_name": "BHX"
    },
    {
      "name": "Glasgow Airport",
      "short_name": "GLA"
    },
    {
      "name": "Edinburgh Airport",
      "short_name": "EDI"
    },
    {
      "name": "Adelaide Airport",
      "short_name": "ADL"
    },
    {
      "name": "Budapest Ferenc Liszt International Airport",
      "short_name": "BUD"
    },
    {
      "name": "Warsaw Chopin Airport",
      "short_name": "WAW"
    },
    {
      "name": "Cape Town International Airport",
      "short_name": "CPT"
    },
    {
      "name": "Johannesburg OR Tambo International Airport",
      "short_name": "JNB"
    }
  ]
  